var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStitcher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4 9v8H0V9h4zm10 0v8h-4V9h4zM9 8v8H5V8h4zm10-1v9h-4V7h4zm5 2v6h-4V9h4z",
    id: "Stitcher_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Stitcher_svg__a",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M4 9v8H0V9h4zm10 0v8h-4V9h4zM9 8v8H5V8h4zm10-1v9h-4V7h4zm5 2v6h-4V9h4z' id='a'/%3E%3C/defs%3E%3Cuse fill='%23000' xlink:href='%23a' fill-rule='evenodd'/%3E%3C/svg%3E";
export { SvgStitcher as ReactComponent };